import React, { createContext, useContext, useReducer, ReactNode } from 'react';
import {
  EmendaParlamentarDetailsState,
  EmendaParlamentarDetailsAction,
  EmendaParlamentarDetailsReducer,
} from './emenda-parlamentar-details-reducer';

const initialState: EmendaParlamentarDetailsState = {
  emendaDetails: null,
  loading: false,
  error: null,
};

const EmendaParlamentarDetailsStateContext = createContext<EmendaParlamentarDetailsState | undefined>(undefined);
const EmendaParlamentarDetailsDispatchContext = createContext<React.Dispatch<EmendaParlamentarDetailsAction> | undefined>(undefined);

interface EmendaParlamentarDetailsProviderProps {
  children: ReactNode;
}

export const EmendaParlamentarDetailsProvider: React.FC<EmendaParlamentarDetailsProviderProps> = ({ children }) => {
  const [state, dispatch] = useReducer(EmendaParlamentarDetailsReducer, initialState);

  return (
    <EmendaParlamentarDetailsStateContext.Provider value={state}>
      <EmendaParlamentarDetailsDispatchContext.Provider value={dispatch}>
        {children}
      </EmendaParlamentarDetailsDispatchContext.Provider>
    </EmendaParlamentarDetailsStateContext.Provider>
  );
};

export const useEmendaParlamentarDetailsState = (): EmendaParlamentarDetailsState => {
  const context = useContext(EmendaParlamentarDetailsStateContext);
  if (context === undefined) {
    throw new Error('useEmendaParlamentarDetailsState must be used within a EmendaParlamentarDetailsProvider');
  }
  return context;
};

export const useEmendaParlamentarDetailsDispatch = (): React.Dispatch<EmendaParlamentarDetailsAction> => {
  const context = useContext(EmendaParlamentarDetailsDispatchContext);
  if (context === undefined) {
    throw new Error('useEmendaParlamentarDetailsDispatch must be used within a EmendaParlamentarDetailsProvider');
  }
  return context;
};
